import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UpgradePlanContactPaylod } from '@edtech-ui/core/models/upgrade-plan/upgrade-plan';
import { UsagePlanService } from '@edtech-ui/core/services/usage-management/usage-plan.service';
import { ToastrService } from 'ngx-toastr';
import { finalize, Subscription, tap } from 'rxjs';

@Component({
	selector: 'app-book-demo-dailog-box',
	standalone: true,
	imports: [ReactiveFormsModule, CommonModule],
	templateUrl: './book-demo-dailog-box.component.html',
	styleUrl: './book-demo-dailog-box.component.scss'
})
export class BookDemoDailogBoxComponent implements OnDestroy {
	demoForm: FormGroup;
	subscription = new Subscription();
	isLoading: boolean = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { plan: string, planName: string, billing: string },
		private dialogRef: MatDialogRef<BookDemoDailogBoxComponent>,
		private _usagePlanService: UsagePlanService,
		private _toastr: ToastrService,
	) {
		this.demoForm = new FormGroup({
			name: new FormControl('', [Validators.required]),
			email: new FormControl('', [Validators.required, Validators.email]),
			organization: new FormControl(''),
			description: new FormControl(''),
			plan: new FormControl(data.plan)
		});
	}

	closeDialog() {
		this.dialogRef.close();
	}

	postUpgradeUsagePlan() {
		if (this.demoForm.valid) {
			this.isLoading = true;

			const payload: UpgradePlanContactPaylod = { ...this.demoForm.value }

			this.subscription.add(
				this._usagePlanService.postUpgradeUsagePlan(payload).pipe(
					tap(response => {
						if (response.Success) {
							this._toastr.success(response.Data.message);
							this.dialogRef.close();

						} else {
							this._toastr.error(response.Message)
						}
					}),
					finalize(() => {
						this.isLoading = false;
					}),
				).subscribe()
			);
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}